import { useState } from "react";
import { apple, logo } from "../assets/icons";
import { playstore, simpleLogo, tickFilled } from "../assets/icons";
import ContactUs from "./ContactUs";
import { subscribeNewsletter } from "../API/axios";
import { Notify } from "../utils/helpfunctions";

function Footer() {
  const [email, setEmail] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSubmitLoading(true);

    await subscribeNewsletter(email)
      .then((res) => {
        if (res.data.success) {
          Notify(res.data.message, "success");
          setIsSubscribed(true);
        } else {
          Notify("Failed to subscribe newsletter.", "error");
        }
      })
      .catch((error) => {
        console.log(error);
        Notify("Failed to subscribe to the newsletter.", "error");
      });

    setSubmitLoading(false);
  };

  return (
    <div className="relative z-[1] w-full h-fit flex flex-col items-center justify-center gap-8 pb-4 bg-white overflow-hidden">
      <div id="contactus" className="w-full mb-8 md:mb-16">
        <ContactUs />
      </div>

      <div className="w-full h-fit px-4 flex gap-8 flex-col md:flex-row justify-around items-center">
        <div className="max-w-[300px] smd:max-w-[400px] md:max-w-[500px] z-10 h-fit text-black flex flex-col gap-4 md:gap-6 my-8">
          <div className="w-fit flex items-center gap-3 text-teal">
            <div className="w-[160px] md:w-[200px]">{logo}</div>
          </div>

          <p className="text-sm md:text-lg">
            Latest news, articles, and resources will be sent to your inbox
            weekly.
          </p>

          {isSubscribed ? (
            <div className="w-full flex items-center gap-2 text-sm">
              <span className="w-5 text-green-500">{tickFilled}</span>
              Thank you. Subscribed to Newsletter successfully.
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="w-full flex gap-2 text-sm">
              <input
                type="email"
                id="email"
                autoComplete="on"
                placeholder="Enter your email"
                required
                className="w-full min-w-[170px] border border-teal focus:border-teal bg-white px-4 py-2.5 rounded-md text-black outline-none focus:ring focus:ring-teal duration-500"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <button
                disabled={submitLoading}
                className="px-6 py-2.5 bg-teal/80 text-white font-semibold hover:bg-teal rounded-md duration-500"
              >
                {submitLoading ? (
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  "Subscribe"
                )}
              </button>
            </form>
          )}

          {/* <div className="w-full flex flex-col gap-1 text-sm font-semibold">
            <p>10/10 Overall rating</p>
            <p className="flex">
              {star}
              {star}
              {star}
              {star}
              {star}
            </p>
          </div> */}
        </div>

        <div className="max-w-[300px] h-fit p-4 text-white flex flex-col gap-4">
          <div
            // href="https://www.synapsify.tech/"
            target="blanck"
            className="w-[170px] md:w-[200px] h-fit rounded-lg bg-black flex items-center gap-2 md:gap-4 px-3 md:px-4 py-3"
          >
            {playstore}
            <span className="w-fit h-full flex flex-col">
              <h1 className="text-sm font-bold">Coming soon...</h1>
              <p className="text-base md:text-[20px] tracking-wide leading-tight">
                Google Play
              </p>
            </span>
          </div>

          <div
            // href="https://www.synapsify.tech/"
            target="blanck"
            className="w-[170px] md:w-[200px] h-fit rounded-lg bg-black flex items-center gap-2 md:gap-4 px-3 md:px-4 py-3"
          >
            {apple}
            <span className="w-fit h-full flex flex-col">
              <h1 className="text-sm font-bold">Coming soon...</h1>
              <p className="text-base md:text-[20px] tracking-wide leading-tight">
                App Store
              </p>
            </span>
          </div>
        </div>
      </div>

      <div className="w-[85%] smd:w-[80%] md:w-[75%] h-48 md:h-14 rounded-[40px] md:rounded-full bg-teal z-10 flex flex-col md:flex-row justify-between items-center gap-8 shadow-lg px-4 py-4 smd:px-6 smd:py-6 md:py-0 md:px-8">
        <span className="w-8 text-white">{simpleLogo}</span>

        <div className="w-full h-full flex flex-col-reverse md:flex-row justify-between items-center">
          <p className="text-gray-300 text-sm text-center md:text-left">
            Copyright © {new Date().getFullYear()} SynapsivateHRM. Powered by{" "}
            <a
              href="https://www.synapsify.tech/"
              target="blanck"
              className="hover:text-white duration-500 text-gray-200 underline underline-offset-2"
            >
              Synapsify
            </a>
            .
          </p>

          <div className="w-fit h-fit whitespace-nowrap flex gap-4">
            {/* <a
              href="https://www.synapsify.tech/"
              target="blanck"
              className="w-8 h-8 flex items-center justify-center text-2xl font-bold rounded-full bg-white text-teal"
            >
              {facebook}
            </a> */}

            {/* <a
              href="https://www.synapsify.tech/"
              target="blanck"
              className="w-8 h-8 flex items-center justify-center text-xl font-bold rounded-full bg-white text-teal pb-0.5 pl-0.5"
            >
              in
            </a> */}

            {/* <a
              href="https://www.synapsify.tech/"
              target="blanck"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-white text-teal"
            >
              {youtube}
            </a> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
